import { render, staticRenderFns } from "./templateUserDetail.vue?vue&type=template&id=9d3dd4c4"
import script from "./templateUserDetail.vue?vue&type=script&lang=js"
export * from "./templateUserDetail.vue?vue&type=script&lang=js"
import style0 from "./templateUserDetail.vue?vue&type=style&index=0&id=9d3dd4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports